import { Autocomplete, Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { useEffect, useState } from "react";
import { useToast } from "src/hooks/useToast";

const OrderMultipleSlabs = ({
  onCloseModal,
  productData,
  onSuccess,
  setItemToAdd,
}: {
  onCloseModal: () => void;
  productData: any;
  onSuccess: () => void;
  setItemToAdd: any;
}) => {
  const [slabList, setSlabList] = useState<any>([]);
  const [selectedSlab, setSelectedSlab] = useState<any[]>([]);

  const { toast } = useToast();

  useEffect(() => {
    setSlabList(productData?.counter_product_slab);
  }, []);

  const handleSelectSlab = async () => {
    try {
      if (!selectedSlab) {
        toast({ description: "Please select a slab", variant: "destructive" });
        return;
      }
      onSuccess();
    } catch (error: any) {
      console.log(error);
    } finally {
      onCloseModal();
    }
  };

  const additionalKey = (() => {
    switch (productData?.priceldentifier?.priceldentifier_id) {
      case 1:
        return "discountonptr_cp";
      case 2:
        return "min_order_qty";
      case 3:
        return "fixedprice_cp";
      default:
        return "";
    }
  })();

  const tertiaryKey = (() => {
    switch (productData?.priceldentifier?.priceldentifier_id) {
      case 2:
        return "max_order_qty";

      default:
        return "";
    }
  })();
  const placeHolderDisplay = (() => {
    switch (productData?.priceldentifier?.priceldentifier_id) {
      case 1:
        return "Price(PTR) - Discount on PTR";
      case 2:
        return "Price(PTR) - Min Qty - Max Qty";
      case 3:
        return "Price(PTR) - Fixed Price";

      default:
        return "";
    }
  })();

  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Select Product Slab </p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="Close" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm mb-2 font-normal text-[#666666]">({productData?.priceldentifier?.description})</p>

      <p className="text-sm mb-2 font-normal text-[#666666]">Choose a product slab to assign </p>

      <Autocomplete
        inputClassName="w-full"
        placeholder={placeHolderDisplay}
        suggestionList={slabList}
        uniqueKey="counterProductSlab_Id"
        displayKey="price"
        additionalDisplayKey={additionalKey}
        tertiaryDisplayKey={tertiaryKey}
        onSelectionChange={(e: any) => {
          setItemToAdd({ ...productData, counter_product_slab: e ? [e] : [] });
          setSelectedSlab(e);
        }}
      />

      <Button loaderSize="small" className="text-white bg-[#8051FF] mt-4" onClick={handleSelectSlab}>
        Assign Slab
      </Button>
    </div>
  );
};

export default OrderMultipleSlabs;
